import { render, staticRenderFns } from "./AddNewForecastCard.vue?vue&type=template&id=1fa39e72&scoped=true"
import script from "./AddNewForecastCard.vue?vue&type=script&lang=ts"
export * from "./AddNewForecastCard.vue?vue&type=script&lang=ts"
import style0 from "./AddNewForecastCard.vue?vue&type=style&index=0&id=1fa39e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa39e72",
  null
  
)

export default component.exports